import type { GridColumnProps } from '@progress/kendo-react-grid';

export const columns: GridColumnProps[] = [
  {
    title: 'Code',
    field: 'PositionCode',
    width: 100,
    className: 'text-left',
  },
  {
    title: 'Description',
    field: 'PositionDesc',
    className: 'text-left',
  },
];
